import { Device } from "@capacitor/device";

type DeviceInformation = {
  deviceName: string;
  deviceModel: string;
  devicePlatform: "ios" | "android" | "web" | "";
  deviceOs: string;
  deviceOsVersion: string;
  deviceIosVersion: number | null;
  deviceAndroidSdkVersion: number | null;
  deviceManufacturer: string;
  deviceIsVirtual: boolean;
  deviceMemUsed: number;
  deviceWebviewVersion: string;
};

export const getDeviceInfo = async (): Promise<DeviceInformation> => {
  try {
    const info = await Device.getInfo();

    const deviceInfo = {
      deviceName: info.name || "",
      deviceModel: info.model || "",
      devicePlatform: info.platform || "",
      deviceOs: info.operatingSystem || "",
      deviceOsVersion: info.osVersion || "",
      deviceIosVersion: info.iOSVersion || null,
      deviceAndroidSdkVersion: info.androidSDKVersion || null,
      deviceManufacturer: info.manufacturer || "",
      deviceIsVirtual: info.isVirtual || false,
      deviceMemUsed: info.memUsed || 0,
      deviceWebviewVersion: info.webViewVersion || "",
    };

    console.log("[RMD]: Device Info", deviceInfo);

    return deviceInfo;
  } catch (e) {
    console.error("[RMD]: Failed to get device info:", e);

    return {
      deviceName: "",
      deviceModel: "",
      devicePlatform: "",
      deviceOs: "",
      deviceOsVersion: "",
      deviceIosVersion: null,
      deviceAndroidSdkVersion: null,
      deviceManufacturer: "",
      deviceIsVirtual: false,
      deviceMemUsed: 0,
      deviceWebviewVersion: "",
    };
  }
};
